import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/synergy/footer';
import Header from '../components/synergy/header';
import HomePage from '../pages/synergy/home_page';
import AboutPage from '../pages/synergy/about_page';
import ContactPage from '../pages/synergy/contact_page';
import PortfolioPage from '../pages/synergy/portfolio_page';

export default function SynergyTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                aboutPage={AboutPage}
                contactPage={ContactPage}
                portfolioPage={PortfolioPage}
            />
            <Footer />
        </React.Fragment>
    )
}
